<template>
  <!-- 编辑设备 -->
  <div class="">
    <v-dialog
      class="popbox"
      name="dialog2"
      v-model="isShow"
      :title="dialogTitle"
      close-on-click-modal
      :modal="true"
      :width="668"
      @open="open"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      append-to-body
    >

      <v-form ref="form" :model="ruleForm" :rules="rules">
        <v-form-item  prop="product_key">
          <template slot="label">
            <span class="required">*</span>
            <span>产品</span>
          </template>
          <v-select id="product_key" disabled name="product_key" :placeholder="productOptins.length > 0 ? '请选择' : '请先新建产品'" v-model="ruleForm.product_key" :options="productOptins"></v-select>
        </v-form-item>
        <v-form-item  prop="dev_name">
          <template slot="label">
            <span class="required">*</span>
            <span>设备名称</span>
          </template>
          <v-input type="text" name="dev_name" v-model="ruleForm.dev_name"></v-input>
        </v-form-item>
        <v-form-item  prop="dev_key">
          <template slot="label">
            <span class="required">*</span>
            <span>设备KEY</span>
          </template>
          <v-input type="text" disabled name="dev_key" v-model="ruleForm.dev_key"></v-input>
        </v-form-item>
        <v-form-item  prop="dev_mac">
          <template slot="label">
            <span class="required">*</span>
            <span>设备MAC</span>
          </template>
          <v-input type="text" disabled name="dev_mac" v-model="ruleForm.dev_mac"></v-input>
        </v-form-item>
      </v-form>
      <v-loading class="loading-box" :visible="!upTips" name="loading4"></v-loading>

    </v-dialog>

  </div>

</template>

<script>
import { copy } from '@/common/libs/utils';

export default {
  components: {},
  props:{
  showInputDialog:{
    type:Boolean,
    default: false
  },
  infoData:{
    type:Object,
    default: ()=>{}
  }
},
  data() {
    return {
      rules: {
        dev_name: copy([{
            type: "nameInput",
            args: [1,32]
          }]),
          dev_key: copy([{
            type: "identifier",
            args: [1,32]
          }]),
          dev_mac: copy([{
            type: "identifier",
            args: [1,32]
          }]),
      },
      ruleForm:{
        dev_name: '',
        dev_key: "",
        product_key: "",
        dev_mac: '',
        app_id: sessionStorage.getItem("appid") || "",
      },
      isShow:false,
      upTips:true,
      dialogTitle:'编辑设备信息',
      productOptins:[]
    };
  },
  created() {
  },
  watch:{
    showInputDialog(newVal){
      this.isShow = newVal
    }
  },
  methods: {
    open(){
      this.getDataList()
      this.ruleForm = copy(this.infoData)
    },
    async getDataList(){
      const subData = {
        page_num: 1,
        page_size: 10000,
        app_id: sessionStorage.getItem("appid") || "",
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/product/page/v1",
        subData,
        false
      );
      if(res.code === 0){
        this.productOptins = res.data.list.map((item) =>{
          return {
            label: item.product_name,
            value: item.product_key,
          }
        })
      }else{
        if(res.code == '100410'){
          setTimeout(() => {
            this.getData()
          },1000)
        }else{
          this.$message.error(res.msg);
        }
      }
    },
    handleConfirm() {
      const valid = this.$refs.form.submitForm();
      if (valid === false) {
        return;
      }
      let submitData = { ...this.ruleForm };
      this.$put("/td/td-iot-api/iot/dev/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit('getData')
          this.$message.success(res.msg);
        }
        else {
          this.$message.error(res.msg);
        }
      });
      this.$emit('update:showInputDialog',false)
    },
    handleAfterClose() {
      this.$emit('update:showInputDialog',false)
    }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
</style>
